import React, { useEffect } from "react";
import { Col, Form, Input, Row, Button } from "antd";
import { useParams } from "react-router-dom";

import { addEditFormLayout as layout } from "../../../utils";
import { addEditInsuranceProps, addEditValuesType } from "../../../models";

const AddEditForm = ({ isAdd, actions, state }: addEditInsuranceProps) => {
  const [form] = Form.useForm<addEditValuesType>();
  const { currentInsurance } = state || {};
  const { id } = useParams();

  useEffect(() => {
    if (!id || !actions.getInsuranceById) {
      return;
    }

    actions.getInsuranceById(id);
  }, []);

  useEffect(() => {
    if (isAdd || !currentInsurance) return;
    form.setFieldsValue(currentInsurance);
  }, [currentInsurance]);

  const onFinish = (values: addEditValuesType) => {
    if (isAdd) {
      actions.addInsurance?.(values);
      return;
    }
    actions.updateInsurance?.(values, currentInsurance?.id);
  };

  return (
    <div className="py-6 px-4">
      <Form
        colon={false}
        {...layout}
        form={form}
        name="basic"
        onFinish={onFinish}
      >
        <Row>
          <Col span={24} md={15} lg={12}>
            <Form.Item
              label="Naziv kompanije"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Unesite naziv kompanije!",
                },
              ]}
            >
              <Input placeholder="Unesite naziv kompanije" />
            </Form.Item>

            <Form.Item
              label="ID broj"
              name="IDNumber"
              rules={[
                {
                  required: true,
                  message: "Unesite ID broj!",
                },
              ]}
            >
              <Input placeholder="Unesite ID broj" />
            </Form.Item>

            <Form.Item
              label="PDV broj"
              name="VATNumber"
              rules={[
                {
                  required: true,
                  message: "Unesite PDV broj!",
                },
              ]}
            >
              <Input placeholder="Unesite PDV broj" />
            </Form.Item>

            <Form.Item
              label="Adresa"
              name="address"
              rules={[
                {
                  required: true,
                  message: "Unesite adresu korisnika!",
                },
              ]}
            >
              <Input placeholder="Unesite adresu korisnika" />
            </Form.Item>

            <Form.Item
              label="Kontakt osoba"
              name="contactPerson"
              rules={[
                {
                  required: true,
                  message: "Unesite kontakt osobu!",
                },
              ]}
            >
              <Input placeholder="Unesite kontakt osobu" />
            </Form.Item>

            <Form.Item
              label="Broj telefona"
              name="phoneNumber"
              rules={[
                {
                  required: true,
                  message: "Unesite broj telefona!",
                },
              ]}
            >
              <Input placeholder="Unesite broj telefona" />
            </Form.Item>
            <Form.Item>
              <Button
                htmlType="submit"
                className="text-sm text-white bg-primary font-medium w-[132px] rounded-sm shadow-sm sm:mt-20"
              >
                SPREMI
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default AddEditForm;
